<template>
  <h3>{{ title }} <span>{{ daysText }}</span></h3>
</template>

<script>
export default {
  name: 'section-title',
  props: {
    title: {
      type: String,
      required: true
    },
    days: {
      type: Number,
      required: true
    }
  },
  computed: {
    daysText() {
      if (this.days === 1) {
        return this.days + " " + this.$gettext('DEN')
      } else if (this.days > 1 && this.days < 5) {
        return this.days + " " + this.$gettext('DNY')
      } else {
        return this.days + " " + this.$gettext('DNÍ')
      }
    }
  }
}
</script>

